import RowItemListHandleLetters from './RowItemListHandleLetters.jsx';

export {
  RowItemListHandleLetters
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/datatable/list/index.js